import {
    AwesomeTableComponent,
    Button,
    HeaderTable,
    IColumnsProps,
    TimeUtils,
    ViewLabelStatus,
} from "d-react-components";
import { debounce } from "lodash";
import React, { useRef } from "react";
import { generatePath, useNavigate } from "react-router";
import { useGetBranchListLazyQuery } from "../../../api/hooks";
import AppLink from "../../../common/AppLink";
import PermissibleRender from "../../../common/PermissibleComponent";
import TableAction from "../../../common/TableActions";
import { BRANCH_STATUS, BRANCH_STATUSES } from "../../../constant/branch";
import { PERMISSION } from "../../../constant/user";
import Messages from "../../../languages/Messages";
import Path from "../../Path";

const BranchTable = () => {
    const tableRef = useRef<any>(null);
    const searchRef = useRef<string>("");
    const navigate = useNavigate();
    const [getListBranch] = useGetBranchListLazyQuery();

    const columns: IColumnsProps = [
        {
            title: Messages.systemId,
            dataIndex: "branchId",
            width: 50,
            align: "center",
            render: (branchId, item) => (
                <AppLink
                    to={generatePath(Path.BRANCH_DETAIL, {
                        branchId: item.id,
                    })}
                >
                    <div className="flex items-center">
                        <span>{`${branchId}`}</span>
                    </div>
                </AppLink>
            ),
        },
        {
            title: Messages.name,
            dataIndex: "name",
            width: 200,
            render: (name, item) => (
                <AppLink
                    to={generatePath(Path.BRANCH_DETAIL, {
                        branchId: item.id,
                    })}
                >
                    <div className="flex items-center">
                        <span>{`${name}`}</span>
                    </div>
                </AppLink>
            ),
        },
        {
            title: Messages.code,
            dataIndex: "code",
        },
        {
            title: Messages.pickupCode,
            dataIndex: "pickupCode",
        },
        {
            title: Messages.phone,
            dataIndex: "phone",
        },
        {
            title: Messages.status,
            dataIndex: "status",
            render: (status) => (
                <ViewLabelStatus
                    status={
                        status ? BRANCH_STATUS.ACTIVE : BRANCH_STATUS.INACTIVE
                    }
                    listStatus={BRANCH_STATUSES}
                    getLabel={(item) => (Messages as any)[item.label]}
                />
            ),
        },
        {
            title: Messages.createAt,
            dataIndex: "createdAt",
            render: TimeUtils.toDateTime,
        },
        {
            title: Messages.action,
            dataIndex: "",
            align: "center",
            render: (data: any) => {
                return (
                    <TableAction
                        onClick={(actionId: string) =>
                            onClickTableAction(actionId, data)
                        }
                    />
                );
            },
        },
    ];

    const onClickTableAction = (actionId: string, item: any) => {
        switch (actionId) {
            default:
                navigate(
                    generatePath(Path.BRANCH_DETAIL, {
                        branchId: item.id,
                    })
                );
        }
    };

    const source = (pagingData: any) => {
        return getListBranch({
            variables: {
                paginate: {
                    page: pagingData?.pageIndex,
                    limit: pagingData?.pageSize,
                    search: searchRef?.current ?? "",
                },
            },
            fetchPolicy: "no-cache",
        });
    };

    const onClickAddNew = () => {
        navigate(Path.BRANCH_CREATE);
    };

    const onChangeSearch = (text: string) => {
        searchRef.current = text;
    };

    const onSubmitSearch = () => {
        tableRef.current.refresh();
    };

    return (
        <div>
            <HeaderTable
                label={Messages.branchWarehouse}
                onClickFilter={() => {}}
                onChangeText={(event: any) =>
                    onChangeSearch(event.target.value)
                }
                onSubmitSearch={onSubmitSearch}
                showFilter={false}
                className="app-layout__page-header"
                customButtons={() => (
                    <PermissibleRender permission={PERMISSION.BRANCH.CREATE}>
                        <Button size="small" onClick={onClickAddNew}>
                            {Messages.new}
                        </Button>
                    </PermissibleRender>
                )}
            />
            <AwesomeTableComponent
                ref={(ref) => {
                    tableRef.current = ref;
                }}
                source={source}
                transformer={(res) => {
                    return res?.data?.listBranchForAdmin?.data ?? [];
                }}
                getTotalItems={(res) => {
                    return (
                        res?.data?.listBranchForAdmin?.pagination?.items ?? 0
                    );
                }}
                columns={columns}
                showSelectColumn
                baseColumnProps={{ width: 100 }}
            />
        </div>
    );
};

export default BranchTable;
